module.exports = __webpack_public_path__ + "static/media/logo@2x.eb907268.png";